import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import printJS from 'print-js';

import { PDFOptions } from 'puppeteer';

/*
  private injector: EnvironmentInjector
  should run in context of the environment because of the httpClient
*/
export function generatePdf(
  apiUrl: string,
  url: string,
  data: any,
  pdfOptions: PDFOptions,
  options: {
    locale?: string;
    lang?: string;
  }
) {
  const formatedData = {
    pdfOptions,
    url,
    data: {
      lang: options.lang,
      locale: options?.locale || 'en',
      ...data,
    },
  };

  console.log('generatePdf');
  const http = inject(HttpClient);

  console.log('generatePdf2', apiUrl, data);
  let headers = new HttpHeaders();
  headers = headers.set('Accept', 'application/pdf');

  return http.post(apiUrl, formatedData, {
    headers,
    responseType: 'blob' as 'json',
    withCredentials: false,
  });
}

export const downloadFile = (data: any, fileName: string) => {
  const downloadURL = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = downloadURL;
  link.download = fileName;

  setTimeout(function () {
    link.click();

    try {
      document.removeChild(link);
    } catch (err) {
      console.log('remove child failed');
    }
  });
};

export const printPdf = (data: any) => {
  const downloadURL = window.URL.createObjectURL(data);
  printJS(downloadURL);
};
